/*
 * *
 *   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *   ~  * No part of this publication may be reproduced, distributed,
 *   ~  * or transmitted in any form or by any means, including photocopying, recording,
 *   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *   ~  * except in the case of brief quotations embodied in critical
 *   ~  * reviews and certain other noncommercial uses permitted by copyright law.
 *   ~  * AUTHOR : bs
 *   ~  * DATE : 29/04/2025 17:36
 *
 */

import { Component, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ActionEvent,
  DataModel,
  DataTab,
  DataTabBuilder,
  DataTabManager,
  DialogType,
  Factory,
  StandardEntity,
  Tab,
} from '@infodata-group/inf-commons';
import { ICrud } from '../interface/crud.interface';
import {
  DialogComponent,
  TabContainerComponent,
} from '@infodata-group/inf-commons-desktop';
import { StandardPageMasterDetailComponent } from '../standard-page-master-detail/standard-page-master-detail.component';
import { StandardPageFormComponent } from '../standard-page-form/standard-page-form.component';
import { TranslateModule } from '@ngx-translate/core';

const LIST_TAB = new Tab('list', 'i18n.commons-lib.standard-page.list', 'list');
LIST_TAB.canClose = false;

@Component({
  selector: 'infl-standard-page-tab-container',
  standalone: true,
  imports: [
    CommonModule,
    StandardPageMasterDetailComponent,
    StandardPageFormComponent,
    TranslateModule,
    TabContainerComponent,
    DialogComponent,
  ],
  templateUrl: './standard-page-tab-container.component.html',
  styleUrl: './standard-page-tab-container.component.scss',
})
export class StandardPageTabContainerComponent<T extends StandardEntity> {
  protected readonly dialogType = DialogType;

  @Input({ required: true }) model: DataModel;
  @Input({ required: true }) factory: Factory<T>;
  @Input({ required: true }) CRUD: ICrud;
  @Input({ required: true }) displayDetails: boolean;

  public tabManager = new DataTabManager<T>();
  protected formType: 'create' | 'edit' = 'create';

  @ViewChild(DialogComponent)
  dialogConfirmBeforeClose: DialogComponent;

  constructor() {
    this.tabManager.addTab(LIST_TAB);
  }

  public onActionClick(event: ActionEvent) {
    switch (event.action.name) {
      case 'create':
        this.addCreateTab();
        break;
      case 'edit':
        this.addEditTab(event.value);
        break;
      case 'consult':
        this.addEditTab(event.value);
        break;
      case 'close':
        this.dialogConfirmBeforeClose.open();
        break;
      case 'post':
      case 'put':
        this.tabManager.closeActiveTab();
        break;
    }
  }

  private addCreateTab() {
    this.formType = 'create';
    const tab = new DataTab(
      'create',
      'i18n.commons-lib.standard-page.new',
      'create',
      null,
    );
    tab.confirmBeforeClose = true;
    this.tabManager.addTab(tab);
  }

  private addEditTab(entity: T): void {
    this.formType = 'edit';
    this.tabManager.addTab(
      new DataTabBuilder(entity).setConfirmBeforeClose(true).build(),
    );
  }

  public onActionDialogConfirmBeforeClose(event: string) {
    if (event !== 'confirm') {
      return;
    }
    this.tabManager.closeActiveTab();
  }
}
